export function sha256PureJS(buffer: Uint8Array): ArrayBuffer {
    const h = [
        0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
        0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
    ];

    const k = [
        0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
        0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
        0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
        0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
        0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
        0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
        0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
        0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
    ];

    const l = buffer.length;
    const bitLength = l * 8;
    const newLength = ((l + 9) + 63 & ~63);
    const padded = new Uint8Array(newLength);
    padded.set(buffer);
    padded[l] = 0x80;

    const view = new DataView(padded.buffer);
    view.setUint32(newLength - 4, bitLength);

    const w = new Uint32Array(64);

    for (let offset = 0; offset < newLength; offset += 64) {
        for (let i = 0; i < 16; i++) {
            w[i] = view.getUint32(offset + i * 4);
        }
        for (let i = 16; i < 64; i++) {
            const s0 = (w[i - 15] >>> 7 | w[i - 15] << 25) ^ (w[i - 15] >>> 18 | w[i - 15] << 14) ^ (w[i - 15] >>> 3);
            const s1 = (w[i - 2] >>> 17 | w[i - 2] << 15) ^ (w[i - 2] >>> 19 | w[i - 2] << 13) ^ (w[i - 2] >>> 10);
            w[i] = Math.trunc(w[i - 16] + s0 + w[i - 7] + s1);
        }

        let a = Math.trunc(h[0]);
        let b = Math.trunc(h[1]);
        let c = Math.trunc(h[2]);
        let d = Math.trunc(h[3]);
        let e = Math.trunc(h[4]);
        let f = Math.trunc(h[5]);
        let g = Math.trunc(h[6]);
        let h_val = Math.trunc(h[7]);

        for (let i = 0; i < 64; i++) {
            const S1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
            const ch = (e & f) ^ (~e & g);
            const temp1 = Math.trunc(h_val + S1 + ch + k[i] + w[i]);
            const S0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
            const maj = (a & b) ^ (a & c) ^ (b & c);
            const temp2 = Math.trunc(S0 + maj);

            h_val = g;
            g = f;
            f = e;
            e = Math.trunc(d + temp1);
            d = c;
            c = b;
            b = a;
            a = Math.trunc(temp1 + temp2);
        }

        h[0] = Math.trunc(h[0] + a);
        h[1] = Math.trunc(h[1] + b);
        h[2] = Math.trunc(h[2] + c);
        h[3] = Math.trunc(h[3] + d);
        h[4] = Math.trunc(h[4] + e);
        h[5] = Math.trunc(h[5] + f);
        h[6] = Math.trunc(h[6] + g);
        h[7] = Math.trunc(h[7] + h_val);
    }

    const result = new Uint8Array(32);
    const resultView = new DataView(result.buffer);
    for (let i = 0; i < 8; i++) {
        resultView.setUint32(i * 4, h[i]);
    }
    return result.buffer;
}